import React from 'react';
import { Grid, TextField, Button } from '@material-ui/core';
import { FileCopy } from '@material-ui/icons';
import useCroppingEffects from './hooks';
import { Camera, Select } from '../../components';

const Cropping = () => {
  const {
    image,
    imageDimension,
    host,
    port,
    configOptions,
    currentConfig,
    croppedAreas,
    currentCroppedArea,
    isCustomArea,
    percentCrop,
    realCrop,
    coordinateProps,
    composeYMLText,
    configYMLText,
    loading,
    classes,
    onConfigChange,
    onCroppedAreaChange,
    onCapture,
    onCropChange,
    onComposeYMLCopy,
    onConfigYMLCopy,
  } = useCroppingEffects();
  return (
    <Grid container spacing={3}>
      <Grid item xs={7}>
        <Camera
          image={image}
          host={host}
          port={port}
          onCapture={onCapture}
          xs={11}
          height={36}
          crop={percentCrop}
          onCropChange={onCropChange}
          disabled={loading}
        />
        <Select
          options={configOptions}
          currentOptionIndex={currentConfig}
          onSelect={onConfigChange}
          label="Config"
          className={classes.select}
        />
      </Grid>
      <Grid item xs={5}>
        <Grid container alignItems="center">
          <p>Image Dimension:</p>
          <p className={classes.largeSpace}>{imageDimension}</p>
        </Grid>
        <Grid container alignItems="center">
          <p>Cropped Area:</p>
          <Select
            options={croppedAreas}
            currentOptionIndex={currentCroppedArea}
            onSelect={onCroppedAreaChange}
            label="Area"
            className={classes.select}
          />
        </Grid>
        <Grid container alignItems="center">
          <p>Crop X:</p>
          <TextField
            {...coordinateProps}
            label="X"
            name="x"
            value={realCrop.x}
          />
          <p className={classes.largeSpace}>Crop Y:</p>
          <TextField
            {...coordinateProps}
            label="Y"
            name="y"
            value={realCrop.y}
          />
        </Grid>
        <Grid className={classes.savedHeight}>
          {isCustomArea && (
            <Grid container alignItems="center">
              <p className={classes.space}>Width:</p>
              <TextField
                {...coordinateProps}
                label="Width"
                name="width"
                value={realCrop.width}
              />
              <TextField
                disabled
                {...coordinateProps}
                label="Ratio"
                name="ratio"
                className={classes.ratio}
                value={(realCrop.height / realCrop.width).toFixed(2)}
              />
              <p className={classes.space}>Height:</p>
              <TextField
                {...coordinateProps}
                label="Height"
                name="height"
                value={realCrop.height}
              />
            </Grid>
          )}
        </Grid>
        <Grid>
          <TextField
            label="docker-compose YML"
            multiline
            minRows={5}
            value={composeYMLText}
            className={classes.textArea}
            variant="outlined"
          />
          <Button
            variant="contained"
            size="large"
            className={classes.button}
            endIcon={<FileCopy />}
            onClick={onComposeYMLCopy}
          >
            Copy
          </Button>
        </Grid>
        <Grid>
          <TextField
            label="Configuration YML"
            multiline
            minRows={5}
            value={configYMLText}
            className={classes.textArea}
            variant="outlined"
          />
          <Button
            variant="contained"
            size="large"
            className={classes.button}
            endIcon={<FileCopy />}
            onClick={onConfigYMLCopy}
          >
            Copy
          </Button>
        </Grid>
      </Grid>
      <Grid className={classes.message}>
        Notice: make sure you copy the settings to the YML
      </Grid>
    </Grid>
  );
};

export default Cropping;
